import filter from "lodash/filter";
import get from "lodash/get";
import * as yup from "yup"; // eslint-disable-line no-restricted-imports
import {
  PURL_SAFE_HELP_MESSAGE,
  PURL_SAFE_PATTERN,
  ZERO_WIDTH_NON_BREAKING_SPACE_CHARACTERS_REGEX,
} from "Constants";

// TODO: Move to @sscs/utils

const getCleanValue = (value: string) =>
  value.replace(ZERO_WIDTH_NON_BREAKING_SPACE_CHARACTERS_REGEX, "").trim();

yup.addMethod(
  yup.array,
  "uniqueProperty",
  function (propertyName = "value", message = "values must be unique") {
    return this.test("isUnique", message, function (list = []) {
      for (let index = list.length - 1; index >= 0; index--) {
        const propertyValue = get(list[index], propertyName);

        if (
          propertyValue &&
          filter(list, [propertyName, propertyValue]).length > 1
        ) {
          throw this.createError({
            path: `${this.path}[${index}].${propertyName}`,
            message,
          });
        }
      }

      return true;
    });
  },
);

const isNotBlank = (value: string) => {
  if (!value) return false;
  return getCleanValue(value) !== "";
};

yup.addMethod(
  yup.string,
  "noInvisibleString",
  function (message = "Value should not be blank") {
    return this.test("noInvisibleString", message, isNotBlank);
  },
);

yup.addMethod(
  yup.string,
  "uniqueSignificantly",
  function (existingValues: string[], message = "Value already exists") {
    return this.test(
      "uniqueSignificantly",
      message,
      (value: string) =>
        !existingValues.map(getCleanValue).includes(getCleanValue(value)),
    );
  },
);

yup.addMethod(
  yup.string,
  "purlSafe",
  function (message = PURL_SAFE_HELP_MESSAGE) {
    return this.test("purlSafe", message, (value: string) =>
      new RegExp(PURL_SAFE_PATTERN, "g").test(value),
    );
  },
);

export * from "yup"; // eslint-disable-line no-restricted-imports
export default yup;
